import React from "react";
import "./indisponivel.css";

function Indisponivel() {
    return (
        <div className="indisponivel-mobile">
            <div className="content-indisponivel-mobile">
                <h2 className="h2-indisponivel-mobile">Indisponível no momento!</h2>
            </div>
        </div>
    );
}

export default Indisponivel;